<div *ngIf="blmDaily" class="daily-article-page">
  <div class="container article-container">
    <div class="article-nav">
      <button mat-stroked-button color="primary" routerLink="/daily">
        <mat-icon>arrow_back</mat-icon> Back to Stories
      </button>
    </div>

    <article class="story-article">
      <header class="article-header">
        <span class="badge" *ngIf="blmDaily.fields.date">{{ blmDaily.fields.date }}</span>
        <h1 class="article-title" [innerHTML]="blmDaily.fields.title | mdToHtml"></h1>
      </header>

      <div class="article-featured-image" *ngIf="blmDaily.fields.images?.[0]?.fields?.file?.url">
        <img [src]="blmDaily.fields.images[0].fields.file.url" [alt]="blmDaily.fields.title">
      </div>

      <div class="article-content" [innerHTML]="blmDaily.fields.longDescription | mdToHtml"></div>
    </article>

    <div class="article-footer">
      <button mat-flat-button color="primary" routerLink="/daily">
        <mat-icon>arrow_back</mat-icon> More Museum Stories
      </button>
    </div>
  </div>
</div>
